<div>
  <div class="step-content">
    <template #dynamicComponent></template>
    <app-step-footer [vertical]="vertical" [hideNext]="hideFooterBtns[1]" [hidePrev]="hideFooterBtns[0]"></app-step-footer>
  </div>
</div>
